export const MARQUEE_ITEMS = [
  "CONTENT IP DEVELOPMENT",
  "HIGH ROAS META CAMPAIGNS",
  "AUDIENCE MONOPOLIZATION",
  "VIRAL SCRIPTWRITING",
  "DRONE & 4K CINEMATOGRAPHY",
  "CONVERSION RATE OPTIMIZATION",
];

export const STATS = [
  { value: 1.45, prefix: "₹", suffix: "Cr+", decimals: 2, label: "Revenue influenced through campaigns" },
  { value: 10, prefix: "", suffix: "K+", decimals: 0, label: "Followers grown via strategic content" },
  { value: 4800, prefix: "", suffix: "%+", decimals: 0, label: "Peak return on ad spend delivered" },
  { value: 20, prefix: "", suffix: "M+", decimals: 0, label: "Organic views driven across platforms" },
];

export const SERVICES = [
  { num: "01", title: "Content Creation & IP Building", description: "Manufacturing recognizable brand IPs, recurring video series, and audience-first content engines that compound attention." },
  { num: "02", title: "Script Writing & Narrative Design", description: "Psychologically tuned, hook-driven scripts engineered to captivate retention and drive action within 3 seconds." },
  { num: "03", title: "Videography & Drone Production", description: "4K cinema-grade cinematography, FPV drone captures, and high-end studio light direction for scroll-stopping visuals." },
  { num: "04", title: "Professional Video Editing", description: "Pacing-perfect post-production with motion graphics, sound design, and color grading built for high retention." },
  { num: "05", title: "Social Media Management", description: "Complete community engineering, distribution architecture, and omnipresent social positioning for your brand." },
  { num: "06", title: "Meta Ads & Paid Campaigns", description: "Data-driven media buying across Meta, YouTube and Google, designed for relentless high-ROAS scaling." },
  { num: "07", title: "High-Intent Lead Generation", description: "Bespoke conversion funnels, landing systems, and automated nurture flows that turn attention into pipeline." },
  { num: "08", title: "Creative Designing & Visual Identity", description: "3D ad graphics, brand design systems, and visual assets engineered for maximum click-through rate." },
];

export const PROCESS = [
  { step: "01", phase: "START", title: "Brand Audit & Content IP Blueprint", description: "In-depth competitor teardown, audience profiling, and positioning architecture. We find the gap your brand will own." },
  { step: "02", phase: "GROW", title: "Production & Content Machine", description: "4K shoots, hook-driven script execution, and organic audience testing until the content engine hums." },
  { step: "03", phase: "AMPLIFY", title: "Performance Paid Campaigns", description: "Winning creatives scaled across Meta & Google with algorithmic precision and ruthless creative testing." },
  { step: "04", phase: "CONVERT", title: "Lead Monopolization & Revenue", description: "Funnel optimization, ROAS tracking, and locked-down customer acquisition. Attention becomes revenue." },
];

export const CASE_STUDIES = [
  {
    id: "tiles",
    client: "Tiles by Trends",
    category: "Luxury Interiors & Retail",
    image: "https://images.unsplash.com/photo-1615873968403-89e068629265?auto=format&fit=crop&w=1080&q=80",
    metrics: [
      { label: "Ad Spend", value: "₹10,000" },
      { label: "Revenue", value: "₹25L+" },
      { label: "ROAS", value: "2500%+" },
    ],
    highlight: "A 2500%+ ROAS engine built via hyper-targeted Meta creatives and video content IPs.",
  },
  {
    id: "bombe",
    client: "Bombe Resort",
    category: "Luxury Hospitality & Tourism",
    image: "https://images.unsplash.com/photo-1561501900-3701fa6a0864?auto=format&fit=crop&w=1080&q=80",
    metrics: [
      { label: "Monthly Spend", value: "₹8–10K" },
      { label: "Monthly Revenue", value: "₹17–18L" },
      { label: "ROAS", value: "1700%+" },
    ],
    highlight: "Monthly booking revenue scaled from scratch with high-converting reels and lead funnels.",
  },
  {
    id: "chillapply",
    client: "Chillapply",
    category: "EdTech & Career SaaS",
    image: "https://images.unsplash.com/photo-1551650975-87deedd944c3?auto=format&fit=crop&w=1080&q=80",
    metrics: [
      { label: "Ad Spend", value: "₹3,00,000" },
      { label: "Revenue", value: "₹1.45Cr+" },
      { label: "ROAS", value: "4800%+" },
    ],
    highlight: "4800%+ ROAS unlocked through viral scriptwriting, founder branding, and algorithmic campaigns.",
  },
];

export const CONTACT = {
  phone: "+91 89041 82425",
  email: "brandedbyknowfinity@gmail.com",
  instagram: "https://instagram.com/brandedbyknowfinity",
  address: "888, 3rd Stage, 7th Main, 9th Cross Rd, BEML Layout, Rajarajeshwari Nagar, Bengaluru, Karnataka 560098",
};
